import { GLTemplate } from '../utils/urlResolver';
import axios from '.';

export const getGLTemplateTypes = () => {
  return axios({
    method: 'GET',
    url: GLTemplate.typesListing,
  });
};

export const getGLTemplateCategories = () => {
  return axios({
    method: 'GET',
    url: GLTemplate.categoriesListing,
  });
};

export const getGLTemplateTransactionTypes = () => {
  return axios({
    method: 'GET',
    url: GLTemplate.transactionsTypeListing,
  });
};

export const getGLTemplates = (params) => {
  return axios({
    method: 'GET',
    url: GLTemplate.listing,
    params,
  });
};

export const getGLTemplateById = (id) => {
  return axios({
    method: 'GET',
    url: `${GLTemplate.individualTemplate}/${id}`,
  });
};

export const addGLTemplate = (data) => {
  return axios({
    method: 'POST',
    url: GLTemplate.add,
    data,
  });
};

export const editGLTemplate = (data) => {
  return axios({
    method: 'PUT',
    url: GLTemplate.edit,
    data,
  });
};

export const getAccountNumber = (params) => {
  return axios({
    method: 'GET',
    url: GLTemplate.accountNumberSearch,
    params,
  });
};

export const getGLTemplatesCount = (params) => {
  return axios({
    method: 'GET',
    url: GLTemplate.templateTotalCount,
    params,
  });
};

export const getIndividualGLTemplate = (id) => {
  return axios({
    method: 'GET',
    url: `${GLTemplate.individualTemplate}/${id}`,
  });
};

export const getGLTemplateId = (params) => {
  return axios({
    method: 'GET',
    url: GLTemplate.templateIdSearch,
    params,
  });
};

export const getGLTemplateName = (params) => {
  return axios({
    method: 'GET',
    url: GLTemplate.templateNameSearch,
    params,
  });
};
